import "./App.css";
import Header from "./Components/Header/Header";
import Form from "./Components/Form/Form";
import { Route, Routes } from "react-router-dom";
import Results from "./Components/Results/Results";
import SinglePost from "./routes/blog/SinglePost/SinglePost";
import CreatePost from "./routes/blog/CreatePost/CreatePost";
import Login from "./routes/auth/Login/Login";
// import Register from "./routes/auth/Register/Register";
import Homepage from "./routes/blog/Homepage/Homepage";
import Footer from "./Components/Footer/Footer";
import DictionaryPage from "./routes/blog/DictionaryPage/DictionaryPage";
import PostListPage from "./routes/blog/PostListPage/PostListPage";
import NotFound from "./routes/NotFound/NotFound";
// import UserManagementPage from "./routes/admin/UserManagementPage";
import UserManagementPage from "./routes/admin/UserManagementPage";

import { Helmet } from "react-helmet-async";

function App() {
  return (
    <div className="app min-h-screen flex flex-col">
      <Helmet>
        <title>GSPEN – კალორიული კალკულატორი & ბლოგი</title>
        <meta
          name="description"
          content="GSPEN – კალორიული კალკულატორი და ბლოგი, რომელიც გეხმარებათ კალორიების დათვლასა და კვების დაგეგმვაში."
        />
        <meta name="robots" content="index,follow,max-snippet:-1" />
        <link rel="canonical" href="https://www.gspen.ge" />
      </Helmet>

      <Header />
      <main className="flex-grow bg-[#F3F4F6]">
        <Routes>
          <Route path="/" element={<Form />} />
          <Route path="/calculator" element={<Form />} />
          <Route path="/results/:ageGroup/:calories" element={<Results />} />
          <Route path="/blog" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/blog/posts" element={<PostListPage />} />
          <Route path="/blog/posts/:id" element={<SinglePost />} />
          <Route path="/blog/write" element={<CreatePost />} />
          <Route path="/dictionary" element={<DictionaryPage />} />
          <Route path="/user-management" element={<UserManagementPage />} />
          {/* <Route path="/test" element={<Test />} /> */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
